import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ToneOfVoicePage = loadAsyncComponent(() => import('./Container'), 'page');
